import { Col, Row } from "react-bootstrap";
import React from "react";
import { useSelector } from "react-redux";
import GoalBottom from "./ResultBottom/GoalBottom";

export default function GoalResult() {
  const bcgResult = useSelector((state) => state.statehome.bcgResult);
  const sdgResult = useSelector((state) => state.statehome.sdgResult);

  return (
    <Row>
      {bcgResult.length ? (
        <Col sm={12} md={12}>
          <div
            className="card-university"
            style={{
              backgroundColor: "#fff",
              borderRadius: "15px",
            }}
          >
            <div className="card-header">
              <h5>BCG</h5>
              <p>จำนวน {bcgResult.length}</p>
            </div>
            <div className="card-university-body">
              <div className="list">
                {bcgResult.map((data, index) => (
                  <div className="detail" key={index}>
                    <h6>
                      <b>โครงการวิจัย : </b> {data.concept_proposal_name_th}
                    </h6>
                    <h6>
                      <b>ปัจจัย :</b> {data.bcg_name}
                    </h6>
                    <hr className="line-researcher" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Col>
      ) : (
        <GoalBottom col={[12, 12, 12]} />
      )}
      {sdgResult.length ? (
        <Col sm={12} md={12}>
          <div
            className="card-university"
            style={{
              backgroundColor: "#fff",
              borderRadius: "15px",
            }}
          >
            <div className="card-header">
              <h5>SDGs</h5>
              <p>จำนวน {sdgResult.length}</p>
            </div>
            <div className="card-university-body">
              <div className="list">
                {sdgResult.map((data, index) => (
                  <div className="detail" key={index}>
                    <h6>
                      <b>โครงการวิจัย : </b> {data.concept_proposal_name_th}
                    </h6>
                    <h6>
                      <b>ปัจจัย :</b> {data.sdgs_name}
                    </h6>
                    <hr className="line-researcher" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Col>
      ) : (
        <GoalBottom col={[12, 12, 12]} />
      )}
    </Row>
  );
}
